"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const PageContent_1 = __importDefault(require("../PageContent"));
const SecurePage_1 = require("../SecurePage");
const ApiHook_1 = require("../../lib/ApiHook");
const Api_1 = require("../../lib/Api");
const DateHelper_1 = require("../../lib/DateHelper");
const ImportForm_1 = __importDefault(require("./ImportForm"));
const ImportLoading_1 = __importDefault(require("./ImportLoading"));
const ImportSuccess_1 = __importDefault(require("./ImportSuccess"));
const ImportFailed_1 = __importDefault(require("./ImportFailed"));
const TimerHooks_1 = require("../../lib/TimerHooks");
const ImportHistory_1 = __importDefault(require("./ImportHistory"));
const ImportUnknown_1 = __importDefault(require("./ImportUnknown"));
const DEFAULT_FROM = DateHelper_1.getStartOfWeek(DateHelper_1.daysAgo(7));
const DEFAULT_TO = DateHelper_1.getEndOfWeek(DateHelper_1.daysAgo(7));
const ImportTimePage = () => {
    var _a, _b, _c;
    const [screen, setScreen] = react_1.useState('Ready');
    const [localConfig, setLocalConfig] = react_1.useState({
        from: DEFAULT_FROM,
        to: DEFAULT_TO
    });
    const [saveApi, startImport] = ApiHook_1.useSideEffectApiHook(Api_1.startHarvestImport);
    const [importStatus, getImportStatus] = ApiHook_1.useApiHook(Api_1.getHarvestImportStatus, undefined, false, true);
    // Poll for status updates
    TimerHooks_1.useInterval(() => {
        var _a, _b, _c;
        const isRunning = ((_a = importStatus.data) === null || _a === void 0 ? void 0 : _a.runtimeStatus) != 'Completed'
            && ((_b = importStatus.data) === null || _b === void 0 ? void 0 : _b.runtimeStatus) != 'Failed'
            && ((_c = importStatus.data) === null || _c === void 0 ? void 0 : _c.runtimeStatus) != 'Terminated';
        if (saveApi.data && isRunning) {
            getImportStatus({
                correlationId: saveApi.data.correlationId,
                instanceId: saveApi.data.instanceId,
                invocationId: Date.now().toString()
            });
        }
    }, 5000);
    react_1.default.useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const isLoading = saveApi.isLoading
            || importStatus.isLoading
            || (saveApi.data && !importStatus.data) // Waiting for initial poll request
            || ((_a = importStatus.data) === null || _a === void 0 ? void 0 : _a.runtimeStatus) == 'ContinuedAsNew'
            || ((_b = importStatus.data) === null || _b === void 0 ? void 0 : _b.runtimeStatus) == 'Pending'
            || ((_c = importStatus.data) === null || _c === void 0 ? void 0 : _c.runtimeStatus) == 'Running';
        const isError = saveApi.isError
            || importStatus.isError
            || ((_d = importStatus.data) === null || _d === void 0 ? void 0 : _d.runtimeStatus) == 'Failed';
        const isSuccess = ((_e = importStatus.data) === null || _e === void 0 ? void 0 : _e.runtimeStatus) == 'Completed';
        if (((_f = saveApi.response) === null || _f === void 0 ? void 0 : _f.httpStatusCode) === 504 || ((_g = saveApi.response) === null || _g === void 0 ? void 0 : _g.httpStatusCode) === 409) // Timed out, or already running
            setScreen('Unknown');
        else if (isLoading)
            setScreen('Loading');
        else if (isSuccess)
            setScreen('Success');
        else if (isError)
            setScreen('Failed');
        else
            setScreen('Ready');
    }, [saveApi, importStatus]);
    return (react_1.default.createElement(SecurePage_1.SecurePage, null,
        react_1.default.createElement(PageContent_1.default, { title: "Import Time Entries" },
            react_1.default.createElement(office_ui_fabric_react_1.Separator, null),
            screen === 'Ready' &&
                react_1.default.createElement(ImportForm_1.default, { initialFromDate: DEFAULT_FROM, initialToDate: DEFAULT_TO, onFromDateChanged: d => setLocalConfig({ ...localConfig, from: d !== null && d !== void 0 ? d : DEFAULT_FROM }), onToDateChanged: d => setLocalConfig({ ...localConfig, to: d !== null && d !== void 0 ? d : DEFAULT_TO }), onSubmit: () => startImport(localConfig) }),
            screen === 'Loading' && react_1.default.createElement(ImportLoading_1.default, null),
            screen === 'Unknown' && react_1.default.createElement(ImportUnknown_1.default, null),
            screen === 'Success' && react_1.default.createElement(ImportSuccess_1.default, { correlationId: (_a = saveApi.data) === null || _a === void 0 ? void 0 : _a.correlationId }),
            screen === 'Failed' && react_1.default.createElement(ImportFailed_1.default, { correlationId: (_b = saveApi.data) === null || _b === void 0 ? void 0 : _b.correlationId }),
            screen !== 'Ready' && ((_c = importStatus.data) === null || _c === void 0 ? void 0 : _c.historyEvents) && react_1.default.createElement(ImportHistory_1.default, { importStatus: importStatus.data }))));
};
exports.default = ImportTimePage;
